import { LeftDrawer } from "pages/Drawer";
import { useLocation } from "react-router-dom";
import React from "react";

const styles = {
  body: {},
};
export const Main = ({ children, ...props }) => {
  const location = useLocation();
  return (
    <main
      className="d-lg-flex d-block layout-main flex-grow-1"
      style={{ ...styles.body }}
      {...props}
    >
      <LeftDrawer />
      <div
        className={
          !location.pathname.includes("add-deceased") && !location.pathname.includes("create-new-class")
            ? "d-flex flex-grow-1 pb-5 justify-content-between left-drawer-side overflow-hidden"
            : "d-flex flex-grow-1 justify-content-between"
        }
        style={
          !location.pathname.includes("add-deceased") && !location.pathname.includes("create-new-class")
            ? { paddingLeft: "30px" }
            : location.pathname.includes("create-new-class") 
            ? { border: "1px solid #E5E5E5", borderBottom: "none" } 
            : {}
        }
      >
        {children}
      </div>
    </main>
  );
};
